const webComponentBoxClasses =
  "w-full self-stretch h-[calc(100svh-10rem)] min-h-[20rem] md:h-[39rem] md:min-h-[24rem] min-[1440px]:h-[40.125rem] min-[1920px]:h-[50rem] group-data-[view=expanded]/shell:md:h-[56rem] group-data-[view=expanded]/shell:min-[1440px]:h-[58rem] group-data-[view=expanded]/shell:min-[1920px]:h-[68rem]";

export default webComponentBoxClasses;
